/*
 * @Author: your name
 * @Date: 2021-04-14 11:19:18
 * @LastEditTime: 2021-10-22 15:57:19
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \鲁南项目\src\modules\reserveImplement\router.js
 */
const routes = [
  {
    path: '/reserveImplement',
    name: 'reserveImplement',
    component: () => import('@src/modules/reserveImplement/view/ReserveImplement'),
    meta: {
      requireAuth: true,
      module:"reserveImplement"
      // routerAlive: true  
    }
  }
]

export default routes
